
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import './collapse-transition-mixin.js';
import 'color';
import 'color-string';
import './color-picker-helper-mixin.js';
import './pendo-tag.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import PendoCard from './pendo-card.js';
import './pendo-divider.js';

function hasNestedProperty(obj, propertyPath, returnVal = false) {
  if (!propertyPath) {
    return false;
  }

  propertyPath = propertyPath.replace(/^\./, '');
  const properties = propertyPath.split('.');

  for (let i = 0; i < properties.length; i++) {
    const prop = properties[i];

    if (!obj || !obj.hasOwnProperty(prop)) {
      return returnVal ? null : false;
    }

    obj = obj[prop];
  }

  return returnVal ? obj : true;
}

function itemIncludes(value, filter) {
  return value.toString().toLowerCase().includes(filter.toString().toLowerCase());
}

function getProp(target, key) {
  const hasNested = hasNestedProperty(target, key, true);
  return hasNested === null ? target[key] : hasNested;
}

function filterItems(prop, item, {
  value
}) {
  const itemValue = getProp(item, prop);

  if (itemValue == null) {
    return false;
  }

  return Array.isArray(value) ? value.some(val => itemIncludes(itemValue, val)) : itemIncludes(itemValue, value);
}

var script = {
  name: 'PendoChooserGrid',
  components: {
    PendoCard,
    PendoButton,
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  props: {
    value: {
      type: [Object, Array, String, Number],
      default: () => []
    },
    items: {
      type: Array,
      default: () => [{}]
    },
    multiple: {
      type: Boolean,
      default: false
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    selectLabel: {
      type: String,
      default: 'Select Item'
    },
    removeSelectionLabel: {
      type: String,
      default: 'Deselect Item'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filters: {
      type: [Object, Array],
      default: null
    }
  },

  data() {
    return {
      filterCache: null
    };
  },

  computed: {
    model() {
      if (this.value || this.value === 0) {
        return Array.isArray(this.value) ? this.value : [this.value];
      }

      return [];
    },

    visibleItems() {
      let visibleItems = this.items;

      if (this.filters && this.filters.length > 0) {
        this.filters.forEach(filter => {
          const value = filter.value,
                prop = filter.prop,
                filterFn = filter.filterFn;

          if (Array.isArray(value) && value.length === 0 || (value === undefined || value === '') && !filterFn) {
            return true;
          }

          const filterHandler = filterFn || this.getFilterHandler(prop);
          visibleItems = visibleItems.filter(item => filterHandler(item, filter));
        });
      }

      return visibleItems;
    }

  },
  watch: {
    visibleItems(visibleItems) {
      this.$emit('visible-items-change', visibleItems);
    }

  },

  created() {
    this.filterCache = Object.create(null);
  },

  methods: {
    getCardShadow(item) {
      if (this.isItemSelected(item)) {
        return 'never';
      }

      if (this.model.length && !this.multiple) {
        return 'never';
      }

      return 'hover';
    },

    isItemSelected(item) {
      return this.model.some(itm => itm[this.valueKey] === item[this.valueKey]);
    },

    removeSelection(item) {
      if (this.disabled || item.disabled) {
        return;
      }

      const indexToRemove = this.model.map(itm => itm[this.valueKey]).indexOf(item[this.valueKey]);
      this.$emit('remove', item);

      if (this.multiple) {
        const newValue = this.model.slice(0, indexToRemove).concat(this.model.slice(indexToRemove + 1));
        this.$emit('input', newValue);
      } else {
        this.$emit('input', null);
      }
    },

    select(item) {
      if (this.isItemSelected(item)) {
        if (this.multiple) {
          this.removeSelection(item);
        }

        return;
      }

      if (this.model.length && !this.multiple) {
        return;
      }

      this.$emit('select', item);

      if (this.multiple) {
        this.$emit('input', this.model.concat([item]));
      } else {
        this.$emit('input', item);
      }
    },

    getFilterHandler(prop) {
      let key;

      if (Array.isArray(prop)) {
        key = prop.join('');
      } else if (typeof prop === 'string' || prop instanceof String) {
        key = prop;
      } else {
        return () => false;
      }

      if (this.filterCache[key]) {
        return this.filterCache[key];
      }

      this.filterCache[key] = (item, filter) => Array.isArray(prop) ? prop.some(prp => filterItems(prp, item, filter)) : filterItems(prop, item, filter);

      return this.filterCache[key];
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-chooser-grid",
    class: {
      'pendo-chooser-grid--multiselect': _vm.multiple,
      'is-disabled': _vm.disabled
    }
  }, [_vm._t("before"), _vm._v(" "), _c('div', {
    staticClass: "pendo-chooser-grid__items"
  }, [_vm._t("items", _vm._l(_vm.visibleItems, function (item) {
    return _c('pendo-card', _vm._b({
      directives: [{
        name: "pendo-tooltip",
        rawName: "v-pendo-tooltip",
        value: item.tooltipOptions,
        expression: "item.tooltipOptions"
      }],
      key: item[_vm.valueKey],
      staticClass: "pendo-chooser-grid__item",
      class: {
        'is-selected': _vm.isItemSelected(item)
      },
      attrs: {
        "shadow": _vm.getCardShadow(item)
      },
      scopedSlots: _vm._u([{
        key: "media",
        fn: function () {
          return [!_vm.$slots[item.media] && !_vm.$scopedSlots[item.media] ? _vm._t("media", null, {
            "item": item,
            "select": _vm.select,
            "removeSelection": _vm.removeSelection,
            "isItemSelected": _vm.isItemSelected
          }) : _vm._e(), _vm._v(" "), !_vm.$slots.media && !_vm.$scopedSlots.media ? _vm._t(item.media, [_vm.multiple && _vm.isItemSelected(item) ? _c('pendo-icon', {
            staticClass: "pendo-chooser-grid__selected-icon",
            attrs: {
              "type": "check-circle-2-solid",
              "stroke": "#FFF",
              "fill": "#229CA8",
              "size": "20"
            }
          }) : _vm._e(), _vm._v(" "), _c('pendo-icon', _vm._b({
            attrs: {
              "size": 40
            }
          }, 'pendo-icon', item.icon, false))], {
            "item": item,
            "select": _vm.select,
            "removeSelection": _vm.removeSelection,
            "isItemSelected": _vm.isItemSelected
          }) : _vm._e()];
        },
        proxy: true
      }, {
        key: "overlay",
        fn: function () {
          return [!_vm.$slots[item.overlay] && !_vm.$scopedSlots[item.overlay] ? _vm._t("overlay", null, {
            "item": item,
            "select": _vm.select,
            "removeSelection": _vm.removeSelection,
            "isItemSelected": _vm.isItemSelected
          }) : _vm._e(), _vm._v(" "), !_vm.$slots.overlay && !_vm.$scopedSlots.overlay ? _vm._t(item.overlay, [!_vm.multiple ? _c('pendo-button', {
            attrs: {
              "theme": "p2-light",
              "type": "secondary",
              "label": _vm.selectLabel
            },
            on: {
              "click": function ($event) {
                return _vm.select(item);
              }
            }
          }) : _vm._e(), _vm._v(" "), _vm.multiple ? _c('pendo-button', {
            attrs: {
              "theme": "p2-light",
              "type": "secondary",
              "label": _vm.isItemSelected(item) ? _vm.removeSelectionLabel : _vm.selectLabel
            },
            on: {
              "click": function ($event) {
                return _vm.select(item);
              }
            }
          }) : _vm._e()], {
            "select": _vm.select,
            "removeSelection": _vm.removeSelection,
            "isItemSelected": _vm.isItemSelected
          }) : _vm._e()];
        },
        proxy: true
      }, {
        key: "title",
        fn: function () {
          return [!_vm.$slots[item.title] && !_vm.$scopedSlots[item.title] ? _vm._t("title", null, {
            "item": item
          }) : _vm._e(), _vm._v(" "), !_vm.$slots.media && !_vm.$scopedSlots.media ? _vm._t(item.media, null, {
            "item": item
          }) : _vm._e()];
        },
        proxy: true
      }, {
        key: "subtitle",
        fn: function () {
          return [!_vm.$slots[item.subtitle] && !_vm.$scopedSlots[item.subtitle] ? _vm._t("subtitle", null, {
            "item": item
          }) : _vm._e(), _vm._v(" "), !_vm.$slots.subtitle && !_vm.$scopedSlots.subtitle ? _vm._t(item.subtitle, null, {
            "item": item
          }) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, 'pendo-card', item, false));
  }))], 2), _vm._v(" "), _vm._t("after")], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-chooser-grid.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoChooserGrid = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoChooserGrid;
